import React from 'react';

// Ikon QR kotak. Dipakai QRIS + metode Duitku QR (satu komponen, konsisten semua).
const QRIcon: React.FC<{ className?: string }> = ({ className }) => (
    <img src="/icons/qris.png" alt="QR" className={className} width={24} height={24} loading="lazy" />
);

export default QRIcon;
